import type { SelectionResolver } from "../../types";
import { SelectionType } from "src/js/stores/map/store";
import { cleanTypename } from "react-migration/lib/util/cleanTypename";
import { feature } from "@turf/helpers";
import { getSiteById } from "react-migration/domains/sites/hooks/useSiteById";

export const sharedSiteSelectionResolver: SelectionResolver = async (siteId) => {
  const site = await getSiteById(siteId, { isShared: true, useCache: false });
  const siteClean = cleanTypename(site);

  if (!siteClean) return null;

  return {
    type: SelectionType.SHARED_SITE,
    id: siteClean._id,
    feature: feature(siteClean.geometry, { shared: true, title: siteClean.title }),
  };
};
